// F-MOTOR-RESERVAS.3.0.1 — Identidade visual oficial Rede Hospeda.
// Fonte: pacote `REDE_HOSPEDA (1).rar` (RGB oficiais + Paleta_Oficial.txt + Manual_Identidade_Visual).
// Esta camada encapsula brand_name / brand_colors / assets para que, em F-SAAS.N,
// estes valores venham de /api/public/tenant/config sem alteração nos componentes públicos.

export const BRAND = {
  name: "Rede Hospeda",
  short: "Rede Hospeda",
  tagline: "Pousadas selecionadas, atendimento próximo",
  whatsapp: "5511914175095",
  email: "contato@grupohospeda.com.br",

  // Ativos oficiais em /app/frontend/public/brand/.
  logoUrl: "/brand/logo.svg",                 // Horizontal: símbolo + wordmark (fundo claro)
  logoMarkUrl: "/brand/logo-mark.svg",        // Apenas o símbolo
  logoWhiteUrl: "/brand/logo-white.svg",      // Logo monocromático branco (fundo escuro)
  logoPngUrl: "/brand/logo-1024.png",         // Fallback PNG 1024×399 (compat redes/email)
  ogImage: "/og-cover.png",                   // Perfil 1080×1080 (temporário; 1200×630 em etapa dedicada)
  faviconUrl: "/favicon.ico",
  appleTouchIconUrl: "/apple-touch-icon.png",

  // Paleta Oficial Rede Hospeda (REDE_HOSPEDA/07_PALETA/Paleta_Oficial.txt).
  colors: {
    azul: "#083A6B",         // Azul Hospeda — primária (confiança, identificação principal)
    dourado: "#D4A652",      // Dourado Acolher — secundária (acolhimento, destaque)
    azulProfundo: "#052B50", // Azul Profundo — fundos escuros e contraste institucional
    creme: "#F5F1E8",        // Creme Claro — fundos claros e atmosfera acolhedora
    cinza: "#6B7280",        // Cinza Apoio — textos secundários e interface
    branco: "#FFFFFF",
  },
};

export function waMessage(context) {
  if (!context) return `Olá! Gostaria de informações sobre as pousadas da ${BRAND.name}.`;
  if (context.type === "pousada") {
    return `Olá! Gostaria de informações sobre a ${context.nome}.`;
  }
  if (context.type === "quarto") {
    const q = context.numero || "o quarto";
    const p = context.pousadaNome ? ` da ${context.pousadaNome}` : "";
    return `Olá! Gostaria de informações sobre ${q}${p}.`;
  }
  return `Olá! Gostaria de informações sobre as pousadas da ${BRAND.name}.`;
}
